// Copyright (c) 2026 Isolated Networks. All rights reserved.
// Proprietary and confidential. Unauthorized copying, distribution, or use
// of this file, via any medium, is strictly prohibited.
// SPDX-License-Identifier: LicenseRef-Proprietary

import React, { useEffect, useState } from 'react';
import { isMaintenance, subscribeMaintenance } from '../utils/maintenanceMode';

// Fixed top banner shown while a restore is running (the backend is intentionally
// down and live updates are paused). Self-contained / plain styles so it can mount
// anywhere in the tree without depending on MUI theme or app contexts.
export default function MaintenanceBanner() {
  const [active, setActive] = useState(isMaintenance());
  useEffect(() => subscribeMaintenance(setActive), []);
  if (!active) return null;
  return (
    <div
      role="status"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 21000,
        background: '#0098DF',
        color: '#fff',
        textAlign: 'center',
        padding: '8px 16px',
        fontSize: 14,
        fontWeight: 600,
        letterSpacing: 0.2,
        fontFamily: '"Inter", system-ui, Segoe UI, Helvetica, Arial, sans-serif',
        boxShadow: '0 2px 8px rgba(0,0,0,0.35)',
      }}
    >
      Restore in progress — live updates are paused while the databases are restored. The dashboard
      will resume automatically.
    </div>
  );
}
